// CustomAddressHelpDialog.jsx
// MUI dialog matching the screenshot

import React from "react";
import { useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Stack,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";

const TITLE_COLOR = "var(--color-primary)";
const BORDER = "rgba(0,0,0,0.12)";

export default function CustomAddressHelpDialog({ open, onClose }) {
  const i18n = useSelector((state) => state.i18n);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
          width: "684px"
        },
      }}
    >
      {/* Title Row */}
      <DialogTitle
        sx={{
          px: 3,
          pt: 2.5,
          pb: 1.5,
          m: 0,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <InfoOutlinedIcon sx={{ color: TITLE_COLOR }} />
          <Typography
            component="div"
            sx={{ fontSize: 22, fontWeight: 500, color: TITLE_COLOR, flex: 1 }}
          >
            {i18n?.customerPortal_helpTitle}
          </Typography>

          <IconButton onClick={onClose} edge="end" aria-label="close">
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>

      <Divider sx={{ borderColor: BORDER, mb: 0 }} />

      {/* Content */}
      <DialogContent sx={{ px: 3, pt: 2.25, pb: 2.5 }}>
        <Typography sx={{ mb: 2 }}>
          {i18n?.customerPortal_helpIntro}
        </Typography>

        {/* 1 */}
        <Box sx={{ mb: 2.5 }}>
          <Typography
            component="h3"
            sx={{ fontSize: 20, fontWeight: 500, mb: 1 }}
          >
           &nbsp;&nbsp; {i18n?.customerPortal_helpStep1Title}
          </Typography>
          <Typography sx={{ mb: 1.5 }}>
            {i18n?.customerPortal_helpStep1Body}
          </Typography>
          <Typography>
            {i18n?.customerPortal_helpStep1StatusPrefix}
            <b style={{ fontWeight: 500}}> {i18n?.customerPortal_helpStatusLabel}</b><br/>
            “{i18n?.customerPortal_helpStep1StatusValue}”.
          </Typography>
        </Box>

        {/* 2 */}
        <Box sx={{ mb: 2.5 }}>
          <Typography
            component="h3"
            sx={{ fontSize: 20, fontWeight: 500, mb: 1 }}
          >
          &nbsp;&nbsp;  {i18n?.customerPortal_helpStep2Title}
          </Typography>
          <Typography sx={{ mb: 1.25 }}>
            {i18n?.customerPortal_helpStep2Body}
          </Typography>

          <List dense sx={{ pl: 2 }}>
            <ListItem sx={{ py: 0.5 }}>
              <ListItemText
                primary={
                  <Typography>
                    <b>{i18n?.customerPortal_helpDnsTitle}</b> {i18n?.customerPortal_helpDnsBody}
                  </Typography>
                }
              />
            </ListItem>
            <ListItem sx={{ py: 0.5 }}>
              <ListItemText
                primary={
                  <Typography>
                    <b>{i18n?.customerPortal_helpProxyTitle}</b> {i18n?.customerPortal_helpProxyBody}
                  </Typography>
                }
              />
            </ListItem>
          </List>

          <Typography sx={{ mt: 1 }}>
            {i18n?.customerPortal_helpStep2Footer}
            <b style={{ fontWeight: 500}}> {i18n?.customerPortal_helpStatusLabel}</b><br/>
            “{i18n?.customerPortal_helpStep2StatusValue}”.
          </Typography>
        </Box>

        {/* Actions (left-aligned like screenshot) */}
        <Box sx={{ my: 3 }}>
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              bgcolor: TITLE_COLOR,
              "&:hover": { bgcolor: "#0B3342" },
              borderRadius: 1,
              px: 2.25,
              boxShadow: "none",
            }}
          >
            {i18n?.customerPortal_closeWindow}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
